module.exports = __webpack_public_path__ + "static/medograf-extraimg1@2x-min-dd44d4a2746d2e0751361feb73ad8a20.png";